(function () {
  var SECTION_SELECTOR = '.oddit-section-editorial-gallery';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-editorial-gallery__products');
    var fill = section.querySelector('.oddit-section-editorial-gallery__progress-fill');
    if (!track || !fill) return;

    var progress = fill.parentNode;

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) {
        progress.style.display = 'none';
        return;
      }
      progress.style.display = '';
      var visible = track.clientWidth / track.scrollWidth;
      fill.style.width = visible * 100 + '%';
      fill.style.left = (track.scrollLeft / maxScroll) * (100 - visible * 100) + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(updateProgress).observe(track);
    updateProgress();
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();